module.exports = __webpack_public_path__ + "img/arboleado.0f4123ca.png";